import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { ContentRoute } from '../../../_metronic/layout' 
import DevicesList from './devices-list/DevicesList';

export default function DevicesPage() {
    return (
        <Switch>

            <Redirect exact={true} from={ "/devices"} to={ "/devices/list"} />
            <ContentRoute from={ "/devices/list"} component={DevicesList} />
            {/* <ContentRoute from="/devices/default-settings" /> */}
        </Switch>
    )
}
